import { Injectable } from "@angular/core";
import { NotificationViewmodel } from "../../../models/notifications";
import { TranslationService } from "../../../services/translation.service";
import { TranslationKey } from "./translation-key";
import moment from 'moment';
import { AppointmentStatusEnum } from "../../../models/enums";

@Injectable({
  providedIn: "root",
})
export class TranslationHelper {
  constructor(private translationService: TranslationService) { }
  getDescription(model: NotificationViewmodel) {
    var message = this.translationService.translate(
      (x) => x.Notifications.Messages[model.description]
    );
    var content = JSON.parse(model.jsonContent);
    switch (model.description) {
      case TranslationKey.NewAppointment:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`)
          .replace("{2}", content.providerName)
          .replace("{3}", content.patientName)
      case TranslationKey.Rescheduled:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`)
          .replace("{2}", content.providerName)
          .replace("{3}", content.patientName)
      case TranslationKey.StatusChanged:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", AppointmentStatusEnum[content.status].toLowerCase())
          .replace("{2}", content.providerName)
          .replace("{3}", content.patientName)
          .replace("{4}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`);
      case TranslationKey.NewUnavailableSlot:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`);
      case TranslationKey.UnavailableSlotUpdated:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`);
      case TranslationKey.UnavailableSlotRemoved:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", `${moment(content.startDateTime).format('l')} [${moment(content.startDateTime).format('LT')} to ${moment(content.endDateTime).format('LT')}]`);
      case TranslationKey.OrderConfirmed:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", content.purchaseOrderNo);
      case TranslationKey.OrderShipped:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", content.purchaseOrderNo);
      case TranslationKey.OrderRejected:
        return message
          .replace("{0}", content.cliniCode)
          .replace("{1}", content.purchaseOrderNo);
      default:
        break;
    }
  }
}
